module.exports = __webpack_public_path__ + "img/question4.3d214f05.svg";